export default {
	state: {
		customers: [],
		shiftSummeries: [],
		customerSummary: {}
	},

	actions: {
		getCustomers(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile

					var columns = "" +
						"distinct " +
						"c.id, " +
						"c.name, " +
						"c.ndisnumber, " +
						"c.combinedaddress, " +
						"c.email, " +
						"c.risknotification, " +
						"c.generalnotes, " +
						"c.dateofbirth, " +
						"c.homephone, " +
						"c.mobilephone, " +
						"keyworker.name as keyworkername, " +
						"genderValue.name as gendername, " +
						"ri.img as profilepic";

					var tableName = "" +
						"@db.client c " +
						"left join @db.clientcareworkers ccw on c.id = ccw.clientid " +
						"left join @db.recordimage ri on c.id = ri.recordid and ri.tablename = 'client' " +
						"left join @db.user keyworker on c.keyworker = keyworker.id " +
						"left join @db.def_fields gender on gender.tableid = 33 and gender.name = 'gender' " +
						"inner join @db.def_ddloptions genderValue on gender.id = genderValue.fieldid and c.gender = genderValue.value";

					var filter = "" +
						"ccw.userid = " + profile.userid + " " +
						"or c.lastname like '%admin%'";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setCustomers", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getClientShiftSummary(actionContext, clientId) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetClientShiftSummaryV2?accounttype=${profile.accounttype}&userid=${profile.userid}&clientid=${clientId}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setShiftSummeries", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getCustomerSummary(actionContext, clientid) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetClientSummary?clientid=${clientid}`)
						.then(response => {
							actionContext.commit("setCustomerSummary", response.data)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setCustomers(state, customers) {
			state.customers = customers
		},
		setShiftSummeries(state, shiftSummeries) {
			state.shiftSummeries = shiftSummeries
		},
		setCustomerSummary(state, customerSummary) {
			state.customerSummary = customerSummary
		}
	},

	namespaced: true
}